// extracted by mini-css-extract-plugin
export default {"app":"app___UPalD","main":"main___Yscm2","nav":"nav___mF5aj"};